import { share, logoVimeo, logoFacebook, logoInstagram, logoTwitter, camera, videocam, image, musicalNote, library, chevronBackSharp, chevronForwardSharp, options, text } from 'ionicons/icons';
import { Plugins, CameraResultType, CameraSource, CameraPhoto, Capacitor,FilesystemDirectory } from '@capacitor/core';



const { Camera, Filesystem,VoiceRecorder } = Plugins;

export const CAMERA = async () => {
    const options = {
        quality: 100,
        // allowEditing: true,
        // source: CameraSource.Camera,
        resultType: CameraResultType.Uri
      };
  
      const originalPhoto = await Camera.getPhoto(options);
      const photoInTempStorage = await Filesystem.readFile({path : originalPhoto.path! });
  
       let date = new Date(),
        time = date.getTime(),
        fileName = time + ".jpeg";
  
      const file: any = base64ToImage('data:image/png;base64, '+ photoInTempStorage.data.toString());
      const fileOfBlob = new File([file], fileName);
  
      const formdata = new FormData(); 
      formdata.append('file', fileOfBlob);
      return formdata;
    }


  // Convert base64 to blob
  
export const  base64ToImage = (dataURI: String) => {
    const fileDate = dataURI.split(',');
    const byteString = atob(fileDate[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/png' });
    return blob;
  }
  
